<style scpoed>

.top-margin {
  margin-left: 5px
}

</style>

<template>

  <list-template ref="list-template" :hasSearch="false" :queryParams="searchInfo"
                 actionUrl="question/findQuestionsForAdmin.action">
    <template slot="search" scope="scope">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item v-belong-to-admin >
          <channel-select @change="channelChange"></channel-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="startEndTime" end-placeholder="结束时间" placeholder="按发布时间筛选" start-placeholder="开始时间"
                          type="datetimerange" @change="$refs['list-template'].loadList()">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchInfo.keyword" placeholder="昵称/帖子关键词" type="primary"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button placeholder="昵称/帖子关键词" type="warning" @click="$router.push({name:'官方发帖'})">官方发帖</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="search()" type="primary" >搜索</el-button>
        </el-form-item>
      </el-form>

    </template>
    <template slot="item" scope="scope">
      <div>
        <el-card v-for="data in scope.datas" class="basic-margin">
          <el-row>
            <el-col :span="18">
              <el-col :span="24">
                <p>
                  <el-tag v-if="data.top" type="danger">置顶</el-tag>
                  <el-tag v-show="data.imgs" style="margin-left:5px;margin-right:5px;" type="success">图</el-tag>
                  <span style="font-size:16px;"><b>{{ data.title }} </b></span></p>
              </el-col>
            </el-col>
            <el-col :span="6" style="padding-left:70px;">
              <div>
                <el-button :disabled="data.del=='1'" type="text" @click="deleteQuestion(data.id)">
                  {{ data.del == 1 ? '已删除' : '删除' }}
                </el-button>
                <span style="margin-left:5px;margin-right:5px;color:#eee;">|</span>
                <el-button type="text" @click="show(data.id)">查看详情</el-button>
                <span style="margin-left:5px;margin-left:5px;color:#eee;">|</span>
                <template v-if="data.del==0">
                  <el-button type="text" @click="openTopeWindow(data.id)">置顶</el-button>
                </template>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top:10px;">
            <el-col :span="3">
              <el-tooltip :content="data.channelNameStr" placement="top">
                <p>{{ data.nickName }} (<span v-for="(item, index) in data.channels">
                              <template v-if="index<3">
                                    {{ item.channelName }}
                              </template>
                          </span>)
                </p>
              </el-tooltip>
            </el-col>

            <el-col :span="15">
              <template v-if="data.categoryText&&data.categoryText.split(',').length>0">

                <el-tag v-for="typeText in data.categoryText.split(',')" style="margin-right:5px;" type="warning">
                  {{ typeText }}
                </el-tag>
              </template>
              <template v-if="data.carCategoryText&&data.carCategoryText.split(',').length>0">

                <el-tag v-for="typeText in data.carCategoryText.split(',')" style="margin-right:5px;" type="success">
                  {{ typeText }}
                </el-tag>
              </template>
            </el-col>

            <el-col :span="6">
              <p>{{ data.createTime | dateTimeFormat }} | {{ data.browseCount }} 浏览 | {{ data.replyCount }} 个回帖 </p>
            </el-col>
          </el-row>

        </el-card>

        <el-dialog :visible.sync="dialogFormVisible" title="置顶">
          <el-form :model="questionForm">
            <el-form-item label="置顶结束时间">
              <el-date-picker
                  v-model="questionForm.endDateTime"
                  placeholder="选择日期时间"
                  type="datetime"
                  value-format="timestamp">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="pushTop">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </template>
  </list-template>

</template>

<script>
import channelSelect from '@/components/channelSelect'
import QuestionModel from '../../framework/models/questionModel'
import Config from '../../framework/configs/Config'
import BasicPager from '../../mixins/BasicPager'
import ListTemplate from '../../components/ListTemplate'

export default {
  name: 'question-management',
  extends: BasicPager,
  data: function () {
    return {
      dialogFormVisible: false,
      questionForm: {
        id: null,
        endDateTime: null
      },
      baseImageUrl: Config.imageUrl,
      startEndTime: null,
      searchInfo: {
        keyword: '',
        startTime: null,
        endTime: null,
        channelId: null,
        sourceType: 2
      }
    }
  },
  components: {
    ListTemplate,
    channelSelect
  },
  watch: {
    startEndTime: function (newValue) {
      if (newValue && newValue[0] && newValue[1]) {
        this.searchInfo.startTime = newValue[0].getTime()
        this.searchInfo.endTime = newValue[1].getTime()
      } else {
        this.searchInfo.startTime = null
        this.searchInfo.endTime = null
      }
    }
  },
  created: function () {
    let loginInfo = this.getLoginInfo()
    if (loginInfo.loginPath == 'channel') {
      this.searchInfo.channelId = loginInfo.id
    }
  },
  methods: {
    search:function (){
      this.$refs['list-template'].loadList()
    },
    deleteQuestion: function (questionId) {
      this.$confirm('此操作将删除该帖子, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          questionId: questionId
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              type: 'success',
              message: '删除成功!'
            })
            _this.$refs['list-template'].loadList()
          }
        }
        QuestionModel.deleteQuestion(_this, params, listener)
      })
    },
    openTopeWindow(id) {
      this.dialogFormVisible = true
      this.questionForm.id = id
    },
    pushTop: function () {
      let _this = this
      let param = {
        questionId: _this.questionForm.id,
        endTime: _this.questionForm.endDateTime
      }
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            type: 'success',
            message: '置顶成功!'
          })
          _this.dialogFormVisible = false
          _this.$refs['list-template'].loadList()
        }

      }
      QuestionModel.pushQuestion(_this, param, listener)
    },
    show: function (questionId) {
      this.$router.push({
        name: '帖子详情',
        params: {
          questionId: questionId
        }
      })
    },
    channelChange: function (channelId) {
      this.searchInfo.channelId = channelId
      this.$refs['list-template'].loadList()
    }
    // findAllChannels: function() {
    //     let _this = this
    //     let listener = {
    //         success: function(dataInfo) {
    //             _this.showChannels = dataInfo.datas
    //         }
    //     }
    //     ChannelModel.findAllChannels(_this, listener)
    // }

  }
}

</script>
